import _round from 'lodash/round';

import { padZeroes } from '.';

const secondsPerMinute = 60;
const secondsPerHour = secondsPerMinute * 60;

export const secondsToTimeCode = (
    seconds: number,
    omitZeroHours = true,
): string => {
    const display = {
        seconds,
        minutes: 0,
        hours: 0,
    };

    if (display.seconds >= secondsPerHour) {
        display.hours = Math.floor(display.seconds / secondsPerHour);
        display.seconds -= display.hours * secondsPerHour;
    }

    if (display.seconds >= secondsPerMinute) {
        display.minutes = Math.floor(display.seconds / secondsPerMinute);
        display.seconds -= display.minutes * secondsPerMinute;
    }

    const displayStrings = {
        seconds: padZeroes(_round(display.seconds, 2).toString(), 2),
        minutes: padZeroes(display.minutes.toString(), 2),
        hours: padZeroes(display.hours.toString(), 2),
    };

    if (displayStrings.hours === '00' && omitZeroHours) {
        return `${displayStrings.minutes}:${displayStrings.seconds}`;
    }

    return `${displayStrings.hours}:${displayStrings.minutes}:${displayStrings.seconds}`;
};
